<template>
  <div class="modal-report">
    <SimpleModal>
      <div class="modal-report__top">
        <div class="modal-report__title">Fout rapporteren</div>
        <button class="modal-report__close" @click="closeModalReport">
          <svg svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-45 12 12)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(45 12 12)" d="M11 4h2v16h-2z"/></g></svg>
        </button>
      </div>

      <div class="modal-report__middle">
        <div class="modal-report__p">
          <template v-if="viewInit">
            Staat de melding op de verkeer locatie? Of zelfs in een andere
            gemeente? We horen het graag van u, zodat we onze app en content
            kunnen blijven verbeteren.
          </template>
          <template v-else-if="viewSubmitError">
            Welke reden omschrijft de fout het best?
          </template>
          <template v-else-if="viewReason">
            Toelichting (verplicht)
          </template>
          <template v-else-if="viewBezwaar">
            U wilt bezwaar maken tegen de onderstaandee omgevingsvergunning.
            Helaas kan deze app u daar niet bij helpen. Indien u een bezwaar
            wilt indienen, moet u zich richten tot de instantie die deze
            aanvraag behandelt.
          </template>
        </div>
      </div>

      <div class="modal-report__bottom">
        <div class="modal-report__card">
          <div class="modal-report__card-top">
            <SidebarListItemReport>
              <div class="sidebar-list-item__left">
                <img
                  :src="
                    getCategory(activeFeature.properties.category_id)
                      ? getCategory(activeFeature.properties.category_id)
                          .icon_url
                      : ''
                  "
                  class="sidebar-list-item__left__icon"
                />
              </div>
              <div class="sidebar-list-item__middle">
                <div class="sidebar-list-item__middle__text-title">
                  {{ activeFeature.properties.name }}
                </div>
                <div class="sidebar-list-item__middle__text-subtitle">
                  {{
                    $dayjs(activeFeature.properties.published_at).format("LL")
                  }}
                  -
                  {{ getCategoryName(activeFeature.properties.category_id) }}
                </div>
                <div class="sidebar-list-item__middle__text-subtitle">
                  {{ activeFeature.properties.distance }}m
                </div>
              </div>
            </SidebarListItemReport>
          </div>
          <template v-if="viewInit">
            <div class="modal-report__card-bottom">
              <div class="modal-report__buttons">
                <button
                  class="modal-report__button"
                  :style="{
                    color: this.activePosition.gemeente.app_asset
                      ? this.activePosition.gemeente.app_asset.color_primary
                      : null
                  }"
                  @click="setViewBezwaar"
                >
                  Maak bezwaar
                </button>
                <button
                  class="modal-report__button"
                  @click="setViewSubmitError"
                  :style="{
                    color: this.activePosition.gemeente.app_asset
                      ? this.activePosition.gemeente.app_asset.color_primary
                      : null
                  }"
                >
                  Meld fout
                </button>
              </div>
            </div>
          </template>
          <template v-else-if="viewSubmitError">
            <div class="options">
              <div
                v-for="option in loadedReportTopics.data"
                :class="{
                  option: true,
                  active: activeOption ? activeOption == option : false
                }"
                :key="option.id"
                @click="setActiveOption(option)"
              >
                <div class="option-checkbox"></div>
                <div class="option-text">{{ option.name }}</div>
              </div>
            </div>
            <div class="modal-report__buttons">
              <button
                class="modal-report__button"
                @click="setViewInit"
                :style="{
                  color: this.activePosition.gemeente.app_asset
                    ? this.activePosition.gemeente.app_asset.color_primary
                    : null
                }"
              >
                Vorige
              </button>
              <button
                class="modal-report__button"
                @click="setViewReason"
                :style="{
                  color: this.activePosition.gemeente.app_asset
                    ? this.activePosition.gemeente.app_asset.color_primary
                    : null
                }"
              >
                Volgende
              </button>
            </div>
          </template>
          <template v-else-if="viewReason">
            <textarea
              rows="5"
              v-model="reason"
              placeholder="Selecteer dit veld om te typen"
            ></textarea>
            <div class="modal-report__buttons">
              <button
                class="modal-report__button"
                @click="setViewSubmitError"
                :style="{
                  color: this.activePosition.gemeente.app_asset
                    ? this.activePosition.gemeente.app_asset.color_primary
                    : null
                }"
              >
                Vorige
              </button>
              <button
                class="modal-report__button"
                @click="submitReport"
                :style="{
                  color: this.activePosition.gemeente.app_asset
                    ? this.activePosition.gemeente.app_asset.color_primary
                    : null
                }"
              >
                Verstuur melding
              </button>
            </div>
          </template>
          <template v-else-if="viewBezwaar">
            <div class="modal-report__buttons">
              <button
                class="modal-report__button"
                @click="setViewInit"
                :style="{
                  color: this.activePosition.gemeente.app_asset
                    ? this.activePosition.gemeente.app_asset.color_primary
                    : null
                }"
              >
                Vorige
              </button>
              <a
                href="https://www.rijksoverheid.nl/onderwerpen/bouwregelgeving/vraag-en-antwoord/kan-ik-bezwaar-maken-tegen-de-bouwplannen-of-omgevingsvergunning-van-mijn-buren"
                class="modal-report__button"
                :style="{
                  color: this.activePosition.gemeente.app_asset
                    ? this.activePosition.gemeente.app_asset.color_primary
                    : null
                }"
              >
                Meer informatie
              </a>
            </div>
          </template>
        </div>
      </div>
    </SimpleModal>
    <template v-if="loadedReportTopics">
      aaa4 {{ loadedReportTopics }}
    </template>
    <portal to="page-shadow">
      <PageShadow index="5000" />
    </portal>
  </div>
</template>

<script>
import SimpleModal from "@/components/SimpleModal.vue";
import SidebarListItemReport from "@/components/SidebarListItemReport.vue";
import LoadOrReturnCategories from "@/services/LoadOrReturnCategories.js";
import LoadOrReturnReportTopics from "@/services/LoadOrReturnReportTopics.js";
import PageShadow from "@/components/PageShadow.vue";
import PrivateApi from "@/services/PrivateApi.js";
import CategoryIdToString from "@/services/CategoryIdToString";

export default {
  components: {
    SimpleModal,
    SidebarListItemReport,
    PageShadow
  },
  data() {
    return {
      loadedCategories: null,
      viewInit: true,
      viewSubmitError: false,
      viewReason: false,
      viewBezwaar: false,
      reason: "",
      loadedReportTopics: null,
      activeOption: null
    };
  },
  mounted() {
    let self = this;

    LoadOrReturnCategories().then(function(categories) {
      self.loadedCategories = categories;
    });
    LoadOrReturnReportTopics().then(function(reportTopics) {
      self.loadedReportTopics = reportTopics;
      self.activeOption = reportTopics[0];
    });
  },
  computed: {
    activeFeature() {
      return this.$store.state.ui.activeFeature;
    },
    activePosition() {
      return this.$store.state.ui.activePosition;
    }
  },
  methods: {
    getCategoryName(category_id) {
      let string = CategoryIdToString(category_id);
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getCategory(categoryId) {
      if (this.loadedCategories) {
        return this.loadedCategories.data.find(x => x.id == categoryId);
      }
    },
    closeModalReport() {
      this.$store.commit("closeModalReport");
    },
    setViewInit() {
      this.viewInit = true;
      this.viewSubmitError = false;
      this.viewReason = false;
      this.viewBezwaar = false;
    },
    setViewSubmitError() {
      this.viewInit = false;
      this.viewSubmitError = true;
      this.viewReason = false;
      this.viewBezwaar = false;
    },
    setViewReason() {
      this.viewInit = false;
      this.viewSubmitError = false;
      this.viewReason = true;
      this.viewBezwaar = false;
    },
    setViewBezwaar() {
      this.viewInit = false;
      this.viewSubmitError = false;
      this.viewReason = false;
      this.viewBezwaar = true;
    },
    setActiveOption(option) {
      this.activeOption = option;
    },
    submitReport() {
      let self = this;
      let featureId = this.activeFeature.properties.id;
      let reportTopicId = this.activeOption.id;
      let content = this.reason;

      PrivateApi()
        .post("reports", {
          feature_id: featureId,
          report_topic_id: reportTopicId,
          content: content
        })
        .then(function() {
          self.$store.commit("closeModalReport");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.modal-report {
  text-align: left;

  &__top {
    border-bottom: 1px solid #efefef;
    margin-top: $spacing-4 * -1;
    margin-left: $spacing-4 * -1;
    margin-right: $spacing-4 * -1;
    padding: 0 $spacing-4;
    height: 65px;
    display: flex;
  }

  &__title {
    @extend %text-title-3;
    line-height: 65px;
  }

  &__close {
    margin-left: auto;
    line-height: 65px;
    position: relative;
    top: 9px;
  }

  &__middle {
    text-align: left;
  }

  &__p {
    @extend %text-medium;
    padding: $spacing-4 0;
  }

  &__bottom {
    background-color: #f9f9f9;
    padding: $spacing-4;
    margin: $spacing-4 * -1;
    margin-top: 0;
    border-radius: 0 0 16px 16px;
  }

  &__card {
    border-radius: 16px 16px 0 0;
  }

  &__card-top {
    border: 1px solid #efefef;
    border-radius: 16px 16px 0 0;

    .sidebar-list-item {
      text-align: left;
      border-radius: 16px 16px 0 0;

      &__left {
        &__icon {
        }
      }
      &__middle {
        &__text-title {
        }
        &__text-subtitle {
        }
      }
    }
  }

  &__card-bottom {
  }

  &__buttons {
    display: flex;
  }

  &__button {
    flex: 1;
    height: 50px;
    line-height: 50px;
    background: #fff;
    border: 1px solid #efefef;
    border-top: 0;
    border-left: 0;
    color: $color-black-1;
    @extend %text-medium;

    &:first-child {
      border-radius: 0 0 0 16px;
      border-left: 1px solid #efefef;
    }
    &:last-child {
      border-radius: 0 0 16px 0;
    }
  }
  &__p {
    @extend %text-large;
  }

  .options {
    .option {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #efefef;
      height: 48px;
      border-left: 1px solid #efefef;
      border-right: 1px solid #efefef;
      background: #fff;

      &:hover {
        cursor: pointer;
      }

      .option-checkbox {
        width: 18px;
        height: 18px;
        position: relative;
        border-radius: 100%;
        border: 2px solid #efefef;
        margin: 0 $spacing-3 0 $spacing-4;
      }
      .option-text {
        @extend %text-small;
        color: $color-black-1;
      }
      &.active {
        .option-checkbox {
          border-color: $color-black-1;

          &:after {
            content: "";
            position: absolute;
            top: 2px;
            left: 2px;
            background: $color-black-1;
            height: 10px;
            width: 10px;
            border-radius: 100%;
          }
        }
      }
    }
  }
  textarea {
    width: 100%;
    border: 0;
    border-left: 1px solid #efefef;
    border-right: 1px solid #efefef;
    @extend %text-medium;
    color: $color-black-1;
    padding: $spacing-3;

    &:focus {
      outline: 0;
    }
  }
}
</style>
